import { render, staticRenderFns } from "./paidArticles.vue?vue&type=template&id=d1db7362&scoped=true"
import script from "./paidArticles.vue?vue&type=script&lang=js"
export * from "./paidArticles.vue?vue&type=script&lang=js"
import style0 from "./paidArticles.vue?vue&type=style&index=0&id=d1db7362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1db7362",
  null
  
)

export default component.exports